import { Container, Stack } from "@chakra-ui/react";
import * as React from "react";
import { FaPatreon } from "react-icons/fa6";

import { Patron } from "../api/patron";
import { Upload, getWorkspaceUploads } from "../api/uploads";
import { CreatorShell } from "../components/creator-shell";
import { EmptyState } from "../components/empty-state";
import { UploadsGrid } from "../components/uploads-grid";
import { useLoading, useWorkspace } from "../hooks";

export const PreviewPage = () => {
  const workspace = useWorkspace()!;
  const creator = {
    vanity: workspace.vanity || workspace.name,
    slug: workspace.slug,
    "avatar-url": workspace["avatar-url"],
    "banner-url": workspace["banner-url"],
  };
  const fakePatron: Patron = {
    id: 0,
    "last-visited-at": {},
  };
  const [isLoading, withLoading] = useLoading();
  const [uploads, setUploads] = React.useState<Upload[]>([]);

  React.useEffect(() => {
    withLoading(async () => {
      const data = await getWorkspaceUploads(workspace);
      setUploads(data);
      if (window.location.hash) {
        const elementId = window.location.hash.substring(1);
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          element.style.animation = "highlight 2s ease-out";
        }
      }
    });
  }, [workspace, withLoading]);

  return (
    <Container maxW="3xl" py={8}>
      <CreatorShell creator={creator}>
        <Stack mt={8}>
          {isLoading ? null : uploads.length > 0 ? (
            <UploadsGrid
              creator={creator}
              uploads={uploads}
              patron={fakePatron}
            />
          ) : (
            <EmptyState
              title="No Files Available"
              description="You don't have access to any of this creator's files."
              icon={<FaPatreon />}
            />
          )}
        </Stack>
      </CreatorShell>
    </Container>
  );
};
